import { useState } from "react";
import { BrowserRouter } from "react-router-dom";

import { NestedRoutes } from "./NestedRoutes";

const AppRoutes: React.FC = () => {
  const [BASE_PATH] = useState("/");

  return (
    <BrowserRouter basename={BASE_PATH}>
      <NestedRoutes />
    </BrowserRouter>
  );
};

export { AppRoutes };
